module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sagittarius/sgr_vis-116389d284450179ac7e7a96e6c5702d.jpg";